export const receipt = {
    light: "#FFFBEA",
    dark: "#FFF3C0",
    main: "#FFF6CF",
};
